var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-main',{ref:"main",attrs:{"table-data":_vm.table,"loading":_vm.loading},on:{"submit":_vm.loadGroupData,"groupClick":_vm.groupClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }